import React from "react";

import { Container, Image, Title, TitleWrapper } from "./styles";

export const FullPhoto = ({ data, color }) => {
  return (
    <Container color={color}>
      {data.title && (
        <TitleWrapper>
          <Title>{data.title}</Title>
        </TitleWrapper>
      )}
      <Image>{data.image}</Image>
    </Container>
  );
};
